import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PLAYROOM_ACHIEVEMENTS_SECTION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, PLAYROOM_ACHIEVEMENTS_SECTION_KEY, {
  PAS_TITLE: 'Insignias',
  PAS_DESCRIPTION: 'Descubre tus insignias ganadas o las que puedes desbloquear durante tu aprendizaje.',
  PAS_GOTO_MY_COURSES: 'Ir a cursos',
  PAS_HELP_SECTION_TITLE: '¿Cómo gano puntos una vez obtenidas las insignias?',
  PAS_ERROR_VIEW_TITLE: 'No se cargaron los datos correctamente',
  PAS_ERROR_VIEW_DESCRIPTION: 'Vuelva a cargar la página'
});